import React, { useState, useEffect } from "react";
import { getSettings } from "../../../services/settingsService";

const EmailSMScfg = ({ emailSMScfg = {}, setEmailSMScfg }) => {
    const [emailSMSSettings, setEmailSMSSettings] = useState({
        // General Email Settings
        email_enabled: true,
        sms_enabled: true,
        email_from_name: 'MeddyList',
        email_from_email: 'noreply@meddylist.com',
        email_reply_to: 'support@meddylist.com',
        
        // SMTP Configuration
        smtp_enabled: true,
        smtp_host: 'smtp.gmail.com',
        smtp_port: 587,
        smtp_username: '',
        smtp_password: '',
        smtp_encryption: 'tls', // 'tls', 'ssl', 'none'
        smtp_timeout: 30,
        
        // Email Service Providers
        mailgun_enabled: false,
        mailgun_domain: '',
        mailgun_api_key: '',
        mailgun_region: 'us', // 'us', 'eu'
        
        sendgrid_enabled: false,
        sendgrid_api_key: '',
        sendgrid_from_email: '',
        sendgrid_from_name: '',
        
        aws_ses_enabled: false,
        aws_ses_region: 'us-east-1',
        aws_ses_access_key: '',
        aws_ses_secret_key: '',
        aws_ses_from_email: '',
        
        mailtrap_enabled: false,
        mailtrap_api_token: '',
        mailtrap_inbox_id: '',
        
        // SMS Configuration
        sms_provider: 'smartping', // 'smartping', 'twilio', 'nexmo', 'textlocal', 'msg91'
        
        // Smartping SMS
        smartping_enabled: true,
        smartping_api_key: '',
        smartping_sender_id: '',
        smartping_username: '',
        smartping_password: '',
        
        // Twilio SMS
        twilio_enabled: false,
        twilio_account_sid: '',
        twilio_auth_token: '',
        twilio_phone_number: '',
        
        // Nexmo/Vonage SMS
        nexmo_enabled: false,
        nexmo_api_key: '',
        nexmo_api_secret: '',
        nexmo_from_number: '',
        
        // TextLocal SMS
        textlocal_enabled: false,
        textlocal_api_key: '',
        textlocal_sender: '',
        
        // MSG91 SMS
        msg91_enabled: false,
        msg91_auth_key: '',
        msg91_sender_id: '',
        
        // International SMS Providers
        clickatell_enabled: false,
        clickatell_api_key: '',
        clickatell_from_number: '',
        
        plivo_enabled: false,
        plivo_auth_id: '',
        plivo_auth_token: '',
        plivo_phone_number: '',
        
        // Email Templates Configuration
        welcome_email_enabled: true,
        welcome_email_subject: 'Welcome to MeddyList',
        welcome_email_template: '',
        
        appointment_confirmation_enabled: true,
        appointment_confirmation_subject: 'Appointment Confirmed',
        appointment_confirmation_template: '',
        
        appointment_reminder_enabled: true,
        appointment_reminder_subject: 'Appointment Reminder',
        appointment_reminder_template: '',
        
        payment_confirmation_enabled: true,
        payment_confirmation_subject: 'Payment Confirmed',
        payment_confirmation_template: '',
        
        password_reset_enabled: true,
        password_reset_subject: 'Password Reset Request',
        password_reset_template: '',
        
        email_verification_enabled: true,
        email_verification_subject: 'Verify Your Email',
        email_verification_template: '',
        
        // SMS Templates Configuration
        appointment_sms_enabled: true,
        appointment_sms_template: 'Your appointment is confirmed for {date} at {time} with Dr. {doctor_name}.',
        
        payment_sms_enabled: true,
        payment_sms_template: 'Payment of ₹{amount} received successfully. Transaction ID: {transaction_id}',
        
        otp_sms_enabled: true,
        otp_sms_template: 'Your OTP is {otp}. Valid for 5 minutes. Do not share with anyone.',
        
        reminder_sms_enabled: true,
        reminder_sms_template: 'Reminder: You have an appointment tomorrow at {time} with Dr. {doctor_name}.',
        
        // Notification Settings
        email_notifications_enabled: true,
        sms_notifications_enabled: true,
        push_notifications_enabled: true,
        
        // Rate Limiting
        email_rate_limit: 100, // emails per hour
        sms_rate_limit: 50, // SMS per hour
        daily_email_limit: 1000,
        daily_sms_limit: 500,
        
        // Delivery Settings
        email_retry_attempts: 3,
        sms_retry_attempts: 3,
        email_retry_delay: 300, // seconds
        sms_retry_delay: 60, // seconds
        
        // Analytics
        email_tracking_enabled: true,
        sms_tracking_enabled: true,
        delivery_reports_enabled: true,
        bounce_handling_enabled: true,
        
        // Security
        email_encryption_enabled: true,
        sms_encryption_enabled: true,
        api_key_rotation: false,
        ip_whitelist: '',
        
        // Testing
        test_mode: false,
        test_email: '',
        test_phone: '',
        sandbox_mode: false
    });

    useEffect(() => {
        if (emailSMScfg && Object.keys(emailSMScfg).length > 0) {
            setEmailSMSSettings(prev => ({ ...prev, ...emailSMScfg }));
        }
    }, [emailSMScfg]);

    useEffect(() => {
        getSettings().then(settings => {
            setEmailSMScfg(settings);
        });
    }, []);

    const handleInputChange = (field, value) => {
        const updatedSettings = {
            ...emailSMSSettings,
            [field]: value
        };
        setEmailSMSSettings(updatedSettings);
        setEmailSMScfg(updatedSettings);
    };

    const handleProviderToggle = (provider) => {
        const field = `${provider}_enabled`;
        handleInputChange(field, !emailSMSSettings[field]);
    };

    const EmailProviderSection = ({ title, providers, description }) => (
        <div className="dc-tabsinfo dc-tabsinfo-mt">
            <div className="dc-tabscontenttitle">
                <h3>{title}</h3>
                <p className="text-muted">{description}</p>
            </div>
            <div className="dc-formtheme dc-userform">
                {providers.map((provider) => (
                    <div key={provider.key} className="dc-tabsinfo dc-tabsinfo-mt">
                        <div className="form-group">
                            <div className="dc-checkbox-holder" style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '10px',
                                border: '1px solid #ddd',
                                borderRadius: '5px',
                                marginBottom: '10px'
                            }}>
                                <div>
                                    <label htmlFor={provider.key}>
                                        <span className="dc-checkbox-text" style={{ fontWeight: 'bold' }}>
                                            {provider.name}
                                        </span>
                                    </label>
                                    <p className="text-muted" style={{ margin: '5px 0 0 0', fontSize: '12px' }}>
                                        {provider.description}
                                    </p>
                                </div>
                                <input
                                    type="checkbox"
                                    id={provider.key}
                                    checked={emailSMSSettings[`${provider.key}_enabled`] || false}
                                    onChange={() => handleProviderToggle(provider.key)}
                                    className="dc-checkbox"
                                    style={{ width: '20px', height: '20px' }}
                                />
                            </div>
                        </div>
                        
                        {emailSMSSettings[`${provider.key}_enabled`] && (
                            <div className="row">
                                {provider.fields.map((field) => (
                                    <div key={field.key} className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor={field.key}>{field.label}</label>
                                            {field.type === 'select' ? (
                                                <select
                                                    id={field.key}
                                                    value={emailSMSSettings[field.key] || ''}
                                                    onChange={(e) => handleInputChange(field.key, e.target.value)}
                                                    className="form-control"
                                                    required={field.required}
                                                >
                                                    {field.options.map((option) => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            ) : (
                                                <input
                                                    type={field.type || 'text'}
                                                    id={field.key}
                                                    value={emailSMSSettings[field.key] || ''}
                                                    onChange={(e) => handleInputChange(field.key, e.target.value)}
                                                    placeholder={field.placeholder}
                                                    className="form-control"
                                                    required={field.required}
                                                />
                                            )}
                                            {field.help && (
                                                <small className="form-text text-muted">{field.help}</small>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );

    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-personalskillshold tab-pane active fade show" id="dc-skills">
                <div className="dc-tabsinfo">
                    <div className="dc-tabscontenttitle">
                        <h3>Email & SMS Configuration</h3>
                        <p className="text-muted">Configure email and SMS services for notifications, confirmations, and communications.</p>
                    </div>
                </div>

                {/* General Settings */}
                <div className="dc-tabsinfo dc-tabsinfo-mt">
                    <div className="dc-tabscontenttitle">
                        <h3>General Settings</h3>
                    </div>
                    <div className="dc-formtheme dc-userform">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <div className="dc-checkbox-holder" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        padding: '10px',
                                        border: '1px solid #ddd',
                                        borderRadius: '5px',
                                        marginBottom: '10px'
                                    }}>
                                        <label htmlFor="email_enabled">
                                            <span className="dc-checkbox-text" style={{ fontWeight: 'bold' }}>
                                                Enable Email Service
                                            </span>
                                        </label>
                                        <input
                                            type="checkbox"
                                            id="email_enabled"
                                            checked={emailSMSSettings.email_enabled || false}
                                            onChange={() => handleInputChange('email_enabled', !emailSMSSettings.email_enabled)}
                                            className="dc-checkbox"
                                            style={{ width: '20px', height: '20px' }}
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="email_from_name">From Name</label>
                                    <input
                                        type="text"
                                        id="email_from_name"
                                        value={emailSMSSettings.email_from_name || ''}
                                        onChange={(e) => handleInputChange('email_from_name', e.target.value)}
                                        className="form-control"
                                        placeholder="MeddyList"
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="email_from_email">From Email</label>
                                    <input
                                        type="email"
                                        id="email_from_email"
                                        value={emailSMSSettings.email_from_email || ''}
                                        onChange={(e) => handleInputChange('email_from_email', e.target.value)}
                                        className="form-control"
                                        placeholder="noreply@meddylist.com"
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <div className="dc-checkbox-holder" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        padding: '10px',
                                        border: '1px solid #ddd',
                                        borderRadius: '5px',
                                        marginBottom: '10px'
                                    }}>
                                        <label htmlFor="sms_enabled">
                                            <span className="dc-checkbox-text" style={{ fontWeight: 'bold' }}>
                                                Enable SMS Service
                                            </span>
                                        </label>
                                        <input
                                            type="checkbox"
                                            id="sms_enabled"
                                            checked={emailSMSSettings.sms_enabled || false}
                                            onChange={() => handleInputChange('sms_enabled', !emailSMSSettings.sms_enabled)}
                                            className="dc-checkbox"
                                            style={{ width: '20px', height: '20px' }}
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="sms_provider">SMS Provider</label>
                                    <select
                                        id="sms_provider"
                                        value={emailSMSSettings.sms_provider || 'smartping'}
                                        onChange={(e) => handleInputChange('sms_provider', e.target.value)}
                                        className="form-control"
                                    >
                                        <option value="smartping">Smartping</option>
                                        <option value="twilio">Twilio</option>
                                        <option value="nexmo">Nexmo/Vonage</option>
                                        <option value="textlocal">TextLocal</option>
                                        <option value="msg91">MSG91</option>
                                        <option value="clickatell">Clickatell</option>
                                        <option value="plivo">Plivo</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* SMTP Configuration */}
                <div className="dc-tabsinfo dc-tabsinfo-mt">
                    <div className="dc-tabscontenttitle">
                        <h3>SMTP Configuration</h3>
                        <p className="text-muted">Configure SMTP settings for sending emails</p>
                    </div>
                    <div className="dc-formtheme dc-userform">
                        <div className="form-group">
                            <div className="dc-checkbox-holder" style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '10px',
                                border: '1px solid #ddd',
                                borderRadius: '5px',
                                marginBottom: '10px'
                            }}>
                                <label htmlFor="smtp_enabled">
                                    <span className="dc-checkbox-text" style={{ fontWeight: 'bold' }}>
                                        Enable SMTP
                                    </span>
                                </label>
                                <input
                                    type="checkbox"
                                    id="smtp_enabled"
                                    checked={emailSMSSettings.smtp_enabled || false}
                                    onChange={() => handleInputChange('smtp_enabled', !emailSMSSettings.smtp_enabled)}
                                    className="dc-checkbox"
                                    style={{ width: '20px', height: '20px' }}
                                />
                            </div>
                        </div>
                        {emailSMSSettings.smtp_enabled && (
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="smtp_host">SMTP Host</label>
                                        <input
                                            type="text"
                                            id="smtp_host"
                                            value={emailSMSSettings.smtp_host || ''}
                                            onChange={(e) => handleInputChange('smtp_host', e.target.value)}
                                            className="form-control"
                                            placeholder="smtp.gmail.com"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="smtp_port">SMTP Port</label>
                                        <input
                                            type="number"
                                            id="smtp_port"
                                            value={emailSMSSettings.smtp_port || 587}
                                            onChange={(e) => handleInputChange('smtp_port', parseInt(e.target.value))}
                                            className="form-control"
                                            placeholder="587"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="smtp_username">SMTP Username</label>
                                        <input
                                            type="text"
                                            id="smtp_username"
                                            value={emailSMSSettings.smtp_username || ''}
                                            onChange={(e) => handleInputChange('smtp_username', e.target.value)}
                                            className="form-control"
                                            placeholder="your-email@gmail.com"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="smtp_password">SMTP Password</label>
                                        <input
                                            type="password"
                                            id="smtp_password"
                                            value={emailSMSSettings.smtp_password || ''}
                                            onChange={(e) => handleInputChange('smtp_password', e.target.value)}
                                            className="form-control"
                                            placeholder="App password or account password"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="smtp_encryption">Encryption</label>
                                        <select
                                            id="smtp_encryption"
                                            value={emailSMSSettings.smtp_encryption || 'tls'}
                                            onChange={(e) => handleInputChange('smtp_encryption', e.target.value)}
                                            className="form-control"
                                        >
                                            <option value="tls">TLS</option>
                                            <option value="ssl">SSL</option>
                                            <option value="none">None</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="smtp_timeout">Timeout (seconds)</label>
                                        <input
                                            type="number"
                                            id="smtp_timeout"
                                            value={emailSMSSettings.smtp_timeout || 30}
                                            onChange={(e) => handleInputChange('smtp_timeout', parseInt(e.target.value))}
                                            className="form-control"
                                            min="10"
                                            max="300"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* Email Service Providers */}
                <EmailProviderSection
                    title="Email Service Providers"
                    description="Configure third-party email service providers"
                    providers={[
                        {
                            key: 'mailgun',
                            name: 'Mailgun',
                            description: 'Powerful email API service',
                            fields: [
                                { key: 'mailgun_domain', label: 'Domain', placeholder: 'mg.yourdomain.com', required: true },
                                { key: 'mailgun_api_key', label: 'API Key', type: 'password', placeholder: 'Enter API key', required: true },
                                { key: 'mailgun_region', label: 'Region', type: 'select', options: [
                                    { value: 'us', label: 'US' },
                                    { value: 'eu', label: 'EU' }
                                ], required: true }
                            ]
                        },
                        {
                            key: 'sendgrid',
                            name: 'SendGrid',
                            description: 'Cloud-based email delivery service',
                            fields: [
                                { key: 'sendgrid_api_key', label: 'API Key', type: 'password', placeholder: 'Enter API key', required: true },
                                { key: 'sendgrid_from_email', label: 'From Email', type: 'email', placeholder: 'noreply@yourdomain.com', required: true },
                                { key: 'sendgrid_from_name', label: 'From Name', placeholder: 'Your Company Name', required: true }
                            ]
                        },
                        {
                            key: 'aws_ses',
                            name: 'AWS SES',
                            description: 'Amazon Simple Email Service',
                            fields: [
                                { key: 'aws_ses_region', label: 'Region', placeholder: 'us-east-1', required: true },
                                { key: 'aws_ses_access_key', label: 'Access Key', type: 'password', placeholder: 'Enter access key', required: true },
                                { key: 'aws_ses_secret_key', label: 'Secret Key', type: 'password', placeholder: 'Enter secret key', required: true },
                                { key: 'aws_ses_from_email', label: 'From Email', type: 'email', placeholder: 'noreply@yourdomain.com', required: true }
                            ]
                        },
                        {
                            key: 'mailtrap',
                            name: 'Mailtrap',
                            description: 'Email testing and development service',
                            fields: [
                                { key: 'mailtrap_api_token', label: 'API Token', type: 'password', placeholder: 'Enter API token', required: true },
                                { key: 'mailtrap_inbox_id', label: 'Inbox ID', placeholder: 'Enter inbox ID', required: true }
                            ]
                        }
                    ]}
                />

                {/* SMS Providers */}
                <EmailProviderSection
                    title="SMS Service Providers"
                    description="Configure SMS service providers for sending text messages"
                    providers={[
                        {
                            key: 'smartping',
                            name: 'Smartping',
                            description: 'Popular SMS service in India',
                            fields: [
                                { key: 'smartping_api_key', label: 'API Key', type: 'password', placeholder: 'Enter API key', required: true },
                                { key: 'smartping_sender_id', label: 'Sender ID', placeholder: 'Enter sender ID', required: true },
                                { key: 'smartping_username', label: 'Username', placeholder: 'Enter username', required: true },
                                { key: 'smartping_password', label: 'Password', type: 'password', placeholder: 'Enter password', required: true }
                            ]
                        },
                        {
                            key: 'twilio',
                            name: 'Twilio',
                            description: 'Global cloud communications platform',
                            fields: [
                                { key: 'twilio_account_sid', label: 'Account SID', placeholder: 'Enter account SID', required: true },
                                { key: 'twilio_auth_token', label: 'Auth Token', type: 'password', placeholder: 'Enter auth token', required: true },
                                { key: 'twilio_phone_number', label: 'Phone Number', placeholder: '+1234567890', required: true }
                            ]
                        },
                        {
                            key: 'nexmo',
                            name: 'Nexmo/Vonage',
                            description: 'Global cloud communications platform',
                            fields: [
                                { key: 'nexmo_api_key', label: 'API Key', placeholder: 'Enter API key', required: true },
                                { key: 'nexmo_api_secret', label: 'API Secret', type: 'password', placeholder: 'Enter API secret', required: true },
                                { key: 'nexmo_from_number', label: 'From Number', placeholder: '+1234567890', required: true }
                            ]
                        },
                        {
                            key: 'textlocal',
                            name: 'TextLocal',
                            description: 'SMS service for India and UK',
                            fields: [
                                { key: 'textlocal_api_key', label: 'API Key', type: 'password', placeholder: 'Enter API key', required: true },
                                { key: 'textlocal_sender', label: 'Sender', placeholder: 'Enter sender name', required: true }
                            ]
                        },
                        {
                            key: 'msg91',
                            name: 'MSG91',
                            description: 'SMS service for India',
                            fields: [
                                { key: 'msg91_auth_key', label: 'Auth Key', type: 'password', placeholder: 'Enter auth key', required: true },
                                { key: 'msg91_sender_id', label: 'Sender ID', placeholder: 'Enter sender ID', required: true }
                            ]
                        },
                        {
                            key: 'clickatell',
                            name: 'Clickatell',
                            description: 'International SMS service',
                            fields: [
                                { key: 'clickatell_api_key', label: 'API Key', type: 'password', placeholder: 'Enter API key', required: true },
                                { key: 'clickatell_from_number', label: 'From Number', placeholder: '+1234567890', required: true }
                            ]
                        },
                        {
                            key: 'plivo',
                            name: 'Plivo',
                            description: 'Cloud communications platform',
                            fields: [
                                { key: 'plivo_auth_id', label: 'Auth ID', placeholder: 'Enter auth ID', required: true },
                                { key: 'plivo_auth_token', label: 'Auth Token', type: 'password', placeholder: 'Enter auth token', required: true },
                                { key: 'plivo_phone_number', label: 'Phone Number', placeholder: '+1234567890', required: true }
                            ]
                        }
                    ]}
                />

                {/* Email Templates */}
                <div className="dc-tabsinfo dc-tabsinfo-mt">
                    <div className="dc-tabscontenttitle">
                        <h3>Email Templates</h3>
                        <p className="text-muted">Configure email templates for different types of communications</p>
                    </div>
                    <div className="dc-formtheme dc-userform">
                        {[
                            { key: 'welcome_email', name: 'Welcome Email', subject: 'welcome_email_subject', template: 'welcome_email_template' },
                            { key: 'appointment_confirmation', name: 'Appointment Confirmation', subject: 'appointment_confirmation_subject', template: 'appointment_confirmation_template' },
                            { key: 'appointment_reminder', name: 'Appointment Reminder', subject: 'appointment_reminder_subject', template: 'appointment_reminder_template' },
                            { key: 'payment_confirmation', name: 'Payment Confirmation', subject: 'payment_confirmation_subject', template: 'payment_confirmation_template' },
                            { key: 'password_reset', name: 'Password Reset', subject: 'password_reset_subject', template: 'password_reset_template' },
                            { key: 'email_verification', name: 'Email Verification', subject: 'email_verification_subject', template: 'email_verification_template' }
                        ].map((template) => (
                            <div key={template.key} className="dc-tabsinfo dc-tabsinfo-mt">
                                <div className="form-group">
                                    <div className="dc-checkbox-holder" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        padding: '10px',
                                        border: '1px solid #ddd',
                                        borderRadius: '5px',
                                        marginBottom: '10px'
                                    }}>
                                        <label htmlFor={`${template.key}_enabled`}>
                                            <span className="dc-checkbox-text" style={{ fontWeight: 'bold' }}>
                                                {template.name}
                                            </span>
                                        </label>
                                        <input
                                            type="checkbox"
                                            id={`${template.key}_enabled`}
                                            checked={emailSMSSettings[`${template.key}_enabled`] || false}
                                            onChange={() => handleInputChange(`${template.key}_enabled`, !emailSMSSettings[`${template.key}_enabled`])}
                                            className="dc-checkbox"
                                            style={{ width: '20px', height: '20px' }}
                                        />
                                    </div>
                                </div>
                                {emailSMSSettings[`${template.key}_enabled`] && (
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label htmlFor={template.subject}>Subject</label>
                                                <input
                                                    type="text"
                                                    id={template.subject}
                                                    value={emailSMSSettings[template.subject] || ''}
                                                    onChange={(e) => handleInputChange(template.subject, e.target.value)}
                                                    className="form-control"
                                                    placeholder={`Enter ${template.name} subject`}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label htmlFor={template.template}>Template</label>
                                                <textarea
                                                    id={template.template}
                                                    value={emailSMSSettings[template.template] || ''}
                                                    onChange={(e) => handleInputChange(template.template, e.target.value)}
                                                    className="form-control"
                                                    rows="6"
                                                    placeholder={`Enter ${template.name} template. Use variables like {name}, {email}, {date}, etc.`}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {/* SMS Templates */}
                <div className="dc-tabsinfo dc-tabsinfo-mt">
                    <div className="dc-tabscontenttitle">
                        <h3>SMS Templates</h3>
                        <p className="text-muted">Configure SMS templates for different types of communications</p>
                    </div>
                    <div className="dc-formtheme dc-userform">
                        {[
                            { key: 'appointment_sms', name: 'Appointment SMS', template: 'appointment_sms_template' },
                            { key: 'payment_sms', name: 'Payment SMS', template: 'payment_sms_template' },
                            { key: 'otp_sms', name: 'OTP SMS', template: 'otp_sms_template' },
                            { key: 'reminder_sms', name: 'Reminder SMS', template: 'reminder_sms_template' }
                        ].map((template) => (
                            <div key={template.key} className="dc-tabsinfo dc-tabsinfo-mt">
                                <div className="form-group">
                                    <div className="dc-checkbox-holder" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        padding: '10px',
                                        border: '1px solid #ddd',
                                        borderRadius: '5px',
                                        marginBottom: '10px'
                                    }}>
                                        <label htmlFor={`${template.key}_enabled`}>
                                            <span className="dc-checkbox-text" style={{ fontWeight: 'bold' }}>
                                                {template.name}
                                            </span>
                                        </label>
                                        <input
                                            type="checkbox"
                                            id={`${template.key}_enabled`}
                                            checked={emailSMSSettings[`${template.key}_enabled`] || false}
                                            onChange={() => handleInputChange(`${template.key}_enabled`, !emailSMSSettings[`${template.key}_enabled`])}
                                            className="dc-checkbox"
                                            style={{ width: '20px', height: '20px' }}
                                        />
                                    </div>
                                </div>
                                {emailSMSSettings[`${template.key}_enabled`] && (
                                    <div className="form-group">
                                        <label htmlFor={template.template}>Template</label>
                                        <textarea
                                            id={template.template}
                                            value={emailSMSSettings[template.template] || ''}
                                            onChange={(e) => handleInputChange(template.template, e.target.value)}
                                            className="form-control"
                                            rows="3"
                                            placeholder={`Enter ${template.name} template. Use variables like {name}, {phone}, {date}, {time}, etc.`}
                                        />
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Rate Limiting & Security */}
                <div className="dc-tabsinfo dc-tabsinfo-mt">
                    <div className="dc-tabscontenttitle">
                        <h3>Rate Limiting & Security</h3>
                    </div>
                    <div className="dc-formtheme dc-userform">
                        <div className="row">
                            <div className="col-md-6">
                                <h5>Rate Limiting</h5>
                                <div className="form-group">
                                    <label htmlFor="email_rate_limit">Email Rate Limit (per hour)</label>
                                    <input
                                        type="number"
                                        id="email_rate_limit"
                                        value={emailSMSSettings.email_rate_limit || 100}
                                        onChange={(e) => handleInputChange('email_rate_limit', parseInt(e.target.value))}
                                        className="form-control"
                                        min="1"
                                        max="10000"
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="sms_rate_limit">SMS Rate Limit (per hour)</label>
                                    <input
                                        type="number"
                                        id="sms_rate_limit"
                                        value={emailSMSSettings.sms_rate_limit || 50}
                                        onChange={(e) => handleInputChange('sms_rate_limit', parseInt(e.target.value))}
                                        className="form-control"
                                        min="1"
                                        max="1000"
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <h5>Security</h5>
                                <div className="form-group">
                                    <div className="dc-checkbox-holder" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        padding: '10px',
                                        border: '1px solid #ddd',
                                        borderRadius: '5px',
                                        marginBottom: '10px'
                                    }}>
                                        <label htmlFor="email_encryption_enabled">
                                            <span className="dc-checkbox-text" style={{ fontWeight: 'bold' }}>
                                                Enable Email Encryption
                                            </span>
                                        </label>
                                        <input
                                            type="checkbox"
                                            id="email_encryption_enabled"
                                            checked={emailSMSSettings.email_encryption_enabled || false}
                                            onChange={() => handleInputChange('email_encryption_enabled', !emailSMSSettings.email_encryption_enabled)}
                                            className="dc-checkbox"
                                            style={{ width: '20px', height: '20px' }}
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="ip_whitelist">IP Whitelist</label>
                                    <textarea
                                        id="ip_whitelist"
                                        value={emailSMSSettings.ip_whitelist || ''}
                                        onChange={(e) => handleInputChange('ip_whitelist', e.target.value)}
                                        className="form-control"
                                        rows="3"
                                        placeholder="Enter IP addresses (one per line)"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmailSMScfg;
